import React from "react";
import { Button, Tag, Typography } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import styles from "./OperationRequestWorkspace.module.css";

const { Title } = Typography;

function statusPillColor(status) {
  const s = String(status || "").toLowerCase();
  if (s.includes("מאושר") || s.includes("אושר") || s.includes("שולם") || s.includes("confirmed"))
    return "success";
  if (s.includes("ממתין") || s.includes("pending")) return "warning";
  if (s.includes("ביטול") || s.includes("cancel")) return "error";
  return "default";
}

/**
 * @param {{
 *   onBack: () => void,
 *   title: string,
 *   backLabel?: string,
 *   hideOrderPills?: boolean,
 *   orderStatus: string,
 *   orderKindLabel: string,
 *   supplierSourceLabel: string,
 *   dateRangeLabel: string,
 * }} props
 */
export default function OperationRequestHeader({
  onBack,
  title,
  backLabel = "חזרה להזמנה",
  hideOrderPills = false,
  orderStatus,
  orderKindLabel,
  supplierSourceLabel,
  dateRangeLabel,
}) {
  return (
    <div>
      <div className={styles.headerTopRow}>
        <Button type="default" icon={<ArrowRightOutlined />} onClick={onBack} size="large">
          {backLabel}
        </Button>
      </div>
      <Title level={2} className={styles.title}>
        {title}
      </Title>
      {hideOrderPills ? (
        <div className={styles.pillRow}>
          <Tag className={styles.pill} color="blue">
            {orderKindLabel || "ללא הזמנה"}
          </Tag>
          <Tag className={styles.pill} color="default">
            {orderStatus || "כללי"}
          </Tag>
        </div>
      ) : (
        <div className={styles.pillRow}>
          <Tag className={styles.pill} color={statusPillColor(orderStatus)}>
            {orderStatus || "—"}
          </Tag>
          <Tag className={styles.pill} color="blue">
            {orderKindLabel || "—"}
          </Tag>
          <Tag className={styles.pill}>{supplierSourceLabel || "—"}</Tag>
          <Tag className={styles.pill} color="default">
            {dateRangeLabel || "—"}
          </Tag>
        </div>
      )}
    </div>
  );
}
